import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';
import { AppBar, Tabs, Tab, Box } from '@material-ui/core/';
import { useTranslation } from 'react-i18next';
import CredentialTab from './CredentialTab/CredentialTab';
import RequestTab from './RequestTab/RequestTab';
import { Link } from "react-router-dom";
import { Button, Grid } from "@material-ui/core";
import Search from "../../../components/Search/Search";
import CredentialService from "../../../services/CredentialService/CredentialService";
import CustomizeView from "../../../components/DataTable/CustomizeView/CustomizeView";
import Filters from '../../../components/DataTable/Filters/Filters';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { useSetRecoilState, useRecoilValue } from 'recoil';
import { alertState, rolePermission } from '../../../recoil-store/recoil-state';
import './Credential.css';

//override css material ui tabs 
const TabStyle = withStyles((theme) => ({
    root: {
        fontSize: "12px",
        fontWeight: "700",
        textTransform: "none",
        '&:hover': {
            color: 'var(--gravel) !important',
            opacity: 1,
        },
        '&$selected': {
            color: 'var(--black-pearl)'
        },
    },
    selected: {},
}))((props) => <Tab {...props} />)

const useStyles = makeStyles(theme => ({
    customTabIndicator: {
        height: "3px",
        backgroundColor: "var(--black-pearl)",
        width: "88px!important",
        marginLeft: "35px",
    }
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            className='hei-100'
            {...other}
        >
            {value === index && (
                <Box /*p={1}*/ className='hei-100'>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

function FullWidthTabs(props) {
    const { t } = useTranslation();
    const theme = useTheme();
    const [value, setValue] = useState(0);
    const [data, setData] = useState([]);
    const [searchData, setSearchData] = useState([]);
    const [customColumn, setCustomColumn] = useState([]);
    const [openCustomizeView, setOpenCustomizeView] = useState(false);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false)
    const [searchKeyData, setSearchKeyData] = useState([]);
    const [openFilters, setOpenFilters] = useState(false);
    const setAlert = useSetRecoilState(alertState);
    const permissions = useRecoilValue(rolePermission);
    const classes = useStyles();
    const label = 'CONTENT.CREDENTIAL-TAB.';

    useEffect(() => {
        fetchData(0)
    }, [])


    function handleOpen(open, setState) {
        setState(!open)
    }

    function handleClick() {
        setOpen(!open);
    }

    const fetchData = async (val) => {
        setLoading(true);

        const response = val === 0 ? await CredentialService.getCredentials() : await CredentialService.getCredentialRequest();
        if (response?.status) {
            setData(response.data);
            setSearchData(response.data);
        } else {
            setAlert(alert => ({ ...alert, show: true, message: t(response?.message), severity: 'error' }));
        }
        setValue(val);
        setTimeout(() => {
            setLoading(false);
        }, 300)
    }


    function handleCredentialTabRender() {
        return (
            <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                {permissions?.data.includes('CONNECTION_CREATE') &&
                    <Link style={{ textDecoration: "none" }} to="new">
                        <Button className="searchbar-button">{t(label + 'ADD-NEW-CREDENTIAL')}</Button>
                    </Link>}
                {/* {permissions?.data.includes('CONNECTIONREQUEST_CREATE') && <Button className="searchbar-button"
                    onClick={() => handleClick()}>{t(label + 'NEW-CREDENTIAL-REQUEST')}</Button>} */}
                <Button className="searchbar-button" onClick={() => handleOpen(openCustomizeView, setOpenCustomizeView)}>{t('CONTENT.DATATABLE.TOOLBAR.CUSTOMIZE-VIEW')}</Button>
                <Button className="searchbar-button" onClick={() => handleOpen(openFilters, setOpenFilters)}>{t('CONTENT.DATATABLE.TOOLBAR.FILTERS')}</Button>
            </Grid>
        )
    }

    function handleRequestTabRender() {
        return (
            <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                <Button className="searchbar-button" onClick={() => handleOpen(openCustomizeView, setOpenCustomizeView)}>{t('CONTENT.DATATABLE.TOOLBAR.CUSTOMIZE-VIEW')}</Button>
                <Button className="searchbar-button" onClick={() => handleOpen(openFilters, setOpenFilters)}>{t('CONTENT.DATATABLE.TOOLBAR.FILTERS')}</Button>
            </Grid>
        )
    }

    const handleChange = (event, newValue) => {
        if (newValue === 0) {
            fetchData(0);
        } else {
            fetchData(1);
        }
    };

    return (
        <div id="credential-container" data-test="credential-container" className='data-body-container'>
            <Search data={data} setSearchData={setSearchData} xs={11} sm={11} md={11} lg={4} xl={4} spacing={2}
                searchKey={searchKeyData}>
                {
                    value === 0 ? handleCredentialTabRender() : handleRequestTabRender()
                }

            </Search>
            <AppBar
                id="credential-appbar"
                position="static"
                color="default"
            >
                <Tabs
                    id="credential-tabs"
                    data-test="credential-tabs"
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    aria-label="full width tabs example"
                    classes={{
                        indicator: classes.customTabIndicator
                    }}
                >
                    <TabStyle label={t('CONTENT.CREDENTIAL-TAB.CREDENTIALS')}
                        {...a11yProps(0)} />
                    {/* {permissions?.data.includes('CONNECTIONREQUEST_VIEW') &&
                        <TabStyle label={t('CONTENT.CREDENTIAL-TAB.REQUESTS')}
                            {...a11yProps(1)} />
                    } */}
                </Tabs>
            </AppBar>
            <TabPanel value={value} index={0} dir={theme.direction}>
                <CredentialTab fetchData={fetchData} setOpen={setOpen} customColumn={customColumn} loading={loading}
                    setSearchKeyData={setSearchKeyData} searchData={searchData}
                    setCustomColumn={setCustomColumn} open={open} />
            </TabPanel>
            {/* <TabPanel value={value} index={1} dir={theme.direction}>
                <RequestTab fetchData={fetchData} setOpen={setOpen} customColumn={customColumn} loading={loading}
                    setSearchKeyData={setSearchKeyData} searchData={searchData}
                    setCustomColumn={setCustomColumn} open={open} />
            </TabPanel> */}
            {openCustomizeView && <CustomizeView setOpen={setOpenCustomizeView} customColumn={customColumn}
                setCustomColumn={setCustomColumn} />}
            {openFilters && <Filters setOpen={setOpenFilters} customColumn={customColumn} setCustomColumn={setCustomColumn} />}
        </div>
    );
}

export default FullWidthTabs;
